import escape from 'lodash.escape';
import generatorCellNumber from './generatorCellNumber';

export default (index: any, value: any, rowIndex: any) =>
  `<c r="${generatorCellNumber(index, rowIndex)}" t="inlineStr"><is><t>${escape(
    value
  )}</t></is></c>`;
